export default "__VITE_ASSET__B$TP5xpk__"